import React, { useEffect, useState } from "react";
import "./EmployeeDashboard.css";

const EmployeeDashboard = () => {
  const [employee, setEmployee] = useState(null);

  useEffect(() => {
    const loggedIn = localStorage.getItem("loggedInEmployee");
    if (loggedIn) {
      setEmployee(JSON.parse(loggedIn));
    }
  }, []);

  const studentDetails = [
    { id: 1, name: "Alice Johnson", course: "Java Full Stack", progress: "85%" },
    { id: 2, name: "Michael Smith", course: "React Developer", progress: "90%" },
    { id: 3, name: "Sara Wilson", course: "Python Backend", progress: "75%" },
    { id: 4, name: "David Brown", course: "Node.js API Development", progress: "82%" },
  ];

  if (!employee) {
    return <h2 style={{ textAlign: "center", marginTop: "50px" }}>Please log in first.</h2>;
  }

  return (
    <div className="emp-dashboard">
      <header className="emp-header">
        <h1>Welcome, {employee.name} 👋</h1>
      </header>

      <div className="emp-main">
        {/* Left: Student Details */}
        <div className="student-table glass-card">
          <h2>Student Details</h2>
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Student Name</th>
                <th>Course</th>
                <th>Progress</th>
              </tr>
            </thead>
            <tbody>
              {studentDetails.map((student, index) => (
                <tr key={student.id}>
                  <td>{index + 1}</td>
                  <td>{student.name}</td>
                  <td>{student.course}</td>
                  <td>{student.progress}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Right: Employee Info */}
        <div className="employee-info glass-card">
          <h2>Employee Info</h2>
          <div className="info-item">
            <strong>Name:</strong> <span>{employee.name}</span>
          </div>
          <div className="info-item">
            <strong>Mobile:</strong> <span>{employee.mobile}</span>
          </div>
          <div className="info-item">
            <strong>Email:</strong> <span>{employee.email}</span>
          </div>
          <div className="info-item">
            <strong>Referral Code:</strong> <span>{employee.referral}</span>
          </div>
          <div className="info-item">
            <strong>Position:</strong> <span>{employee.position}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboard;
